import repository from "../Repository";

export default {
  async list(screenId, deliveryNo) {
    return await repository.post(
      "disaster_delivery_detail",
      {
        delivery_no: deliveryNo
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async create(screenId, payload) {
    return await repository.post("disaster_delivery_detail_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.patch("disaster_delivery_detail_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async delete(screenId, payload) {
    return await repository.patch(
      "disaster_delivery_detail_ope/delete",
      payload,
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async translate(screenId, payload) {
    return await repository.post(
      "disaster_delivery_detail_ope/translation",
      payload,
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async resend(screenId, payload) {
    return await repository.patch("disaster_delivery_detail/resend", payload, {
      headers: {
        s: screenId
      }
    });
  }
};
